export const CREDIT_QUALITY_SCORE_TITLE = 'Credit Quality Score (CQS)';
export const FALLEN_ANGEL_SCORE_TITLE = 'Fallen Angel Score (FAS)';
export const AGENCY_COMPOSITE_RATING_TITLE = 'Agency Composite Rating (ACR)';
export const CREDIT_RISK_ESTIMATE_TITLE = 'Credit Risk Estimate (CRE)';
export const COUNTRY_RISK_SCORE_TITLE = 'Country Risk';
export const CURRENT_SCORE = 'Current Score';
export const CQS_OUTLOOK = 'CQS Outlook';
export const CQD = 'Credit Quality Differential (CQD)';
export const FS = 'Fundamental Score (FS)';
// export const PREVIOUS = 'Previous';
export const Y3_PERIOD = '3 Year Period';
export const Y5_PERIOD = '5 Year Period';
export const CRL = 'Credit Risk Level (CRL)';
export const CALCULATION_DATE = 'Calculation Date:';
export const FUNDAMENTAL_DATE = 'Fundamental Report Date:';
export const DATA_DATE = 'Data as of Date:';
export const MODEL = 'Model:';
